var _path, _path2, _path3, _path4, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContainer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M17.9,9.1c0,0.8,0,1.7,0,2.6c0.8,0,1.6,0,2.5,0c-0.2-0.8-0.5-1.7-0.7-2.6C19,9.1,18.5,9.1,17.9,9.1z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6,15.9c-0.3,0-0.5,0.2-0.6,0.5c0,0,0,0.1,0,0.1c0,0.2,0.1,0.3,0.2,0.4c0.1,0.1,0.2,0.1,0.4,0.1 c0.1,0,0.3,0,0.4-0.1c0.1-0.1,0.2-0.3,0.2-0.4c0,0,0-0.1,0-0.1C19.1,16.1,18.9,15.9,18.6,15.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8,16.1c-0.1-0.1-0.3-0.3-0.5-0.3c-0.2,0-0.4,0.1-0.5,0.3c0,0-0.1,0.1-0.1,0.2c0,0,0,0.1,0,0.1 c0,0.2,0.1,0.3,0.2,0.4C3,17,3.2,17,3.3,17c0.1,0,0.3,0,0.4-0.1c0.1-0.1,0.2-0.3,0.2-0.4c0,0,0-0.1,0-0.1 C3.9,16.3,3.9,16.2,3.8,16.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M21,14.3c0,0.3,0,0.6,0,0.9c0.5,0,1,0,1.5,0c0-0.3,0-0.6,0-0.9C22,14.3,21.5,14.3,21,14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M18.6,14.5c-1.1,0-1.9,0.9-1.9,1.9s0.9,1.9,1.9,1.9c1.1,0,1.9-0.9,1.9-1.9S19.7,14.5,18.6,14.5z M19,16.9 C18.9,17,18.8,17,18.6,17c-0.1,0-0.3,0-0.4-0.1c-0.1-0.1-0.2-0.3-0.2-0.4c0,0,0-0.1,0-0.1c0-0.3,0.3-0.5,0.6-0.5s0.5,0.2,0.6,0.5 c0,0,0,0.1,0,0.1C19.2,16.6,19.1,16.8,19,16.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M3.4,14.5L3.4,14.5c-1,0-1.8,0.7-1.9,1.6c0,0.1,0,0.3,0,0.4c0,1.1,0.9,1.9,1.9,1.9s1.9-0.9,1.9-1.9 c0-0.1,0-0.2,0-0.3C5.1,15.2,4.3,14.5,3.4,14.5z M3.7,16.9C3.6,17,3.5,17,3.3,17c-0.1,0-0.3,0-0.4-0.1c-0.1-0.1-0.2-0.3-0.2-0.4 c0,0,0-0.1,0-0.1c0-0.1,0-0.2,0.1-0.2c0.1-0.1,0.3-0.3,0.5-0.3c0.2,0,0.4,0.1,0.5,0.3c0,0,0.1,0.1,0.1,0.2c0,0,0,0.1,0,0.1 C3.9,16.6,3.9,16.8,3.7,16.9z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.7,14.5H1v1.6h0.3l0,0C1.5,15.3,2,14.8,2.7,14.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6,15.1c0-0.9,0-1.8,0-2.6c-0.3-0.1-0.6-0.3-0.8-0.4c-0.2-0.1-0.4-0.2-0.6-0.3c0,0,0,0-0.1,0 c-0.4-0.2-0.4-0.7-0.5-1.1C20.4,10,20.1,9.4,20,8.7c-0.1-0.4-0.2-0.8-0.1-1.3c-1.1,0-2.3,0-3.4,0l0,0l0,0l0,0v1.4l0,0 c0,1.9,0,3.8,0,5.6H4.1c0.7,0.3,1.2,0.8,1.3,1.6l0,0h11c0.3-0.9,1-1.8,2-1.8c1.1-0.2,2.2,0.7,2.4,1.8c0.7,0,1.5,0,2.2,0 c0-0.3,0-0.6,0-0.9C22.9,15.1,22.7,15.1,22.6,15.1z M17.9,11.6c0-0.8,0-1.7,0-2.6c0.6,0,1.1,0,1.7,0c0.2,0.8,0.5,1.7,0.7,2.6 C19.5,11.7,18.7,11.6,17.9,11.6z M22.5,15.2c-0.5,0-1,0-1.5,0c0-0.3,0-0.6,0-0.9c0.5,0,1,0,1.5,0C22.5,14.6,22.5,14.9,22.5,15.2z "
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "1,5.6 1,14.2 16,14.2 16,7.1 16.1,7.1 16.1,5.6  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainer);
export default __webpack_public_path__ + "static/media/container.4e301e64fb8602ad94038ea214aea8d5.svg";
export { ForwardRef as ReactComponent };